const AwsExports = {
  // API: {
  //   endpoints: [
  //     {
  //       name: 'cdcList',
  //       endpoint: 'https://i4iuahxtsd.execute-api.eu-west-1.amazonaws.com/prod',
  //       region: 'eu-west-1'
  //     }
  //   ]
  // },
  Auth: {
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_q7ymlYQ6E',
    identityPoolId: 'eu-west-1:d060c74e-5a1c-4c03-a7b2-9833e328e984',
    userPoolWebClientId: '4108iknheefvqhn4nsk3oc4o7q'
  },
  Analytics: {
    disabled: true
  }
}

export default AwsExports
